<template>
  <div class="work">
    <div class="top">
      <img class="line" src="../../assets/index/line.png" alt="" />
      <div class="title">车间风貌</div>
    </div>
    <div class="part">
      <div class="part1" v-for="(item, index) in datalist" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="img"><img :src="item.image" alt="" /></div>
        <div class="desc">
          {{ item.desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { workshop } from "../../api/request";

export default {
  name: "Workshop",
  data() {
    return {
      datalist: [],
    };
  },
  mounted() {
    workshop().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        this.datalist = res.data.data;
      }
    });
  },
};
</script>

<style scoped lang="less">
.work {
  font-family: 微软雅黑, MicrosoftYaHei;
  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    width: 100%;
    padding: 59px 0;
    .line {
    }
    .title {
      font-size: 42px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
  }
  .part {
    background: #f2f2f2;
    padding-bottom: 100px;
    .part1 {
      width: 1280px;
      margin: 0 auto;
      padding: 20px 0;
      .title {
        text-align: left;
        font-size: 32px;
        color: #004c31;
        padding: 45px 0;
        border-bottom: 1px dotted #dbdbdb;
      }
      .img {
        width: 1280px;
        height: auto;
        margin: 50px 0;
        img {
          width: 1280px;
          height: auto;
        }
      }
      .desc {
        padding-bottom: 37px;
        border-bottom: 1px dotted #dbdbdb;
        text-align: justify;
        font-size: 20px;
        color: #6c7a77;
        line-height: 36px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .work {
    font-family: 微软雅黑, MicrosoftYaHei;
    .top {
      text-align: left;
      margin-left: 320px;
      background: #ffffff;
      width: auto;
      padding: 59px 0;
      .line {
        width: 180px;
        height: 16px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 24 * 2px;
      }
    }
    .part {
      background: #f2f2f2;
      padding-bottom: 100px;
      .part1 {
        width: 1280px;
        margin: 0 auto;
        padding: 20 * 2px 0;
        .title {
          text-align: left;
          font-size: 32 * 2px;
          color: #004c31;
          padding: 45 * 2px 0;
          border-bottom: 1 * 2px dotted #dbdbdb;
        }
        .img {
          width: 1280px;
          height: auto;
          margin: 50 * 2px 0;
          img {
            width: 1280px;
            height: auto;
          }
        }
        .desc {
          padding-bottom: 37 * 2px;
          border-bottom: 1px dotted #dbdbdb;
          text-align: justify;
          font-size: 20 * 2px;
          color: #6c7a77;
          line-height: unset;
        }
      }
    }
  }
}
</style>
